<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<div
    class="agpr-sharedReportCard agpr-contextMenu-parent"
    [ngClass]="{'agpr-sharedReportCard--focused': focused}"
    [agprLoading]="showGlobalLoading"
    [agprGlobalLoading]="true"
    (click)="focusedChanged()"
    (keydown)="onKeydown($event)"

>
    <div
        [id]="'shared-report.' + sharedReportListItem.id"
        class="agpr-sharedReportCard-wrapper card"
        [attr.aria-label]="'Reports.sharedReports.card' | localize: {name: sharedReportListItem.name}"
    >
    <div class="agpr-sharedReportCard-checkboxContainer">
        <span>
            <agpr-checkbox
                [id]="id + '_checkbox'"
                [value]="sharedReportListItem"
                [hiddenLabel]="sharedReportListItem.name"
                (click)="$event.stopPropagation()"
                [(ngModel)]="selectedResults"
                (onChange)="checkedStateChange()"
            ></agpr-checkbox>
        </span>
        <div class="agpr-sharedReportCard-indicator"
             [ngClass]="{'agpr-sharedReportCard-indicator--focused': focused}"
        ></div>
    </div>
        <div class="agpr-sharedReportCard-cardInfo">
            <div class="agpr-sharedReportCard-cardInfo-firstRow">
                <div
                    class="agpr-sharedReportCard-cardInfo-name"
                    [id]="id + '.cardInfo.Name'"
                >
                    {{sharedReportListItem.name}}
                </div>
                <span
                    *ngIf="daysBeforeExpiration <= 30"
                    class="agpr-i-badge-warning agpr-sharedReportCard-cardInfo-warningBadge"
                    role="img"
                    [agprTooltip]="'Reports.sharedReports.daysBeforeExpiration' | localize: {days: daysBeforeExpiration}"
                    tooltipPosition="left"
                ></span>
            </div>
            <div class="agpr-sharedReportCard-cardInfo-secondRow">
                    <div class="agpr-sharedReportCard-cardInfo-createdBy">
                        {{sharedReportListItem.createdBy}}
                    </div>
                <div class="agpr-sharedReportCard-cardInfo-createdDate">
                    @if (preferences) {
                        <agpr-meta-data
                            [id]="id"
                            [icon]="'fa-solid fa-calendar-days'"
                            [value]="sharedReportListItem.createdDate | changeTimeZone: preferences.timeZone: preferences.getDateFormatString(true, true, true)"
                            [tooltip]="'Reports.sharedReports.sortFields.createdDate'"
                        ></agpr-meta-data>
                    }
                </div>
            </div>
        </div>
    </div>
    <div class="agpr-contextMenu top right">
        <agpr-button
            [id]="'shared-report.' + sharedReportListItem.id + '.edit'"
            [style]="buttonTypes.contextMenu"
            [icon]="'fa-regular fa-duotone fa-pen'"
            tooltip="Reports.sharedReports.contextualActions.editReport"
            tooltipPosition="top"
            (click)="editReport()"
        ></agpr-button>
        <a
            [id]="'shared-report.' + sharedReportListItem.id + '.view'"
            [href]="sharedReportsUrl + '/Report/' + this.sharedReportListItem.guid"
            target="_blank"
            class="agpr-sharedReportCard-viewLink"
            [agprTooltip]="'Reports.sharedReports.contextualActions.viewReport' | localize "
            tooltipPosition="top"
        >
            <span class='fa-regular fa-duotone fa-up-right-from-square'></span>
        </a>
        <agpr-button
            [id]="'shared-report.' + sharedReportListItem.id + '.share'"
            [style]="buttonTypes.contextMenu"
            [icon]="'fa-regular fa-duotone fa-share-nodes'"
            tooltip="Reports.sharedReports.contextualActions.shareReport"
            tooltipPosition="top"
            (click)="shareReport()"
        ></agpr-button>
        <agpr-button
            [id]="'shared-report.' + sharedReportListItem.id + '.delete'"
            [style]="buttonTypes.contextMenu"
            [icon]="'fa-regular fa-duotone fa-trash-can'"
            tooltip="Reports.sharedReports.contextualActions.deleteReport"
            tooltipPosition="top"
            (click)="deleteReport()"
        ></agpr-button>
    </div>
</div>
